// extracted by mini-css-extract-plugin
module.exports = {"tooltip-custom-bullet-point":"styles-module__tooltip-custom-bullet-point___2rXZR"};